import React, { PropTypes } from 'react';
import MainMenuLink from './MainMenuLink';

const MainMenu = ({ lang, background, menu, edition }) => (
  <nav className="c-website-menu__item website-menu--main">
    <ul className="c-website-menu__list website-menu--main__list">
      { menu.map(item =>
        <MainMenuLink
          edition={edition}
          lang={lang}
          key={item.item}
          {...item}
          color={background}
        />) }
    </ul>
  </nav>
);

MainMenu.propTypes = {
  edition: PropTypes.string.isRequired,
  background: PropTypes.string.isRequired,
  menu: PropTypes.arrayOf(PropTypes.object).isRequired,
  lang: PropTypes.string.isRequired,
};

export default MainMenu;




// WEBPACK FOOTER //
// ./js/components/menus/MainMenu.js